import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/browser';

const isProduction = process.env.NODE_ENV === 'production';

const initSentry = () => {
  const sentryDsn = process.env.PARCEL_REACT_APP_SENTRY_DSN;

  if (!sentryDsn) {
    console.warn('Sentry DSN not found. Error tracking will be disabled.');
    return;
  }

  try {
    Sentry.init({
      dsn: sentryDsn,
      environment: process.env.NODE_ENV || 'production',
      release: `transpiled@${process.env.REACT_APP_VERSION || '1.0.0'}`,
      debug: false, // Disable debug in production

      // Performance monitoring
      tracesSampleRate: 0.1, // Sample 10% of transactions in production

      // Session Replay
      replaysSessionSampleRate: 0.1, // Sample 10% of sessions
      replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors

      // Integrations
      integrations: [
        new BrowserTracing(),
        new Sentry.Replay({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],

      // Enable capturing console logs
      attachStacktrace: true,
      sendDefaultPii: true, // Include IP, User Agent, etc.

      // Filter out benign errors
      beforeSend(event, hint) {
        // Ignore errors that match certain patterns
        const ignoreErrors = [
          'ResizeObserver loop limit exceeded',
          'ResizeObserver loop completed',
          'ResizeObserver is not defined',
          'Request failed with status code',
          'Network Error',
          'timeout of',
          'Failed to fetch',
        ];

        if (
          hint &&
          hint.originalException &&
          ignoreErrors.some(
            (error) =>
              hint.originalException.message &&
              typeof hint.originalException.message === 'string' &&
              hint.originalException.message.includes(error),
          )
        ) {
          return null;
        }

        return event;
      },
    });

    // Set default user context (will be updated during authentication)
    Sentry.setUser({
      ip_address: '{{auto}}',
    });

    // Logging is handled by the logger utility
    if (!isProduction) {
      // Debug information is available in browser dev tools
      // eslint-disable-next-line no-console
      console.debug('Sentry initialized in development mode');
    }
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
};

export { Sentry, initSentry };
